export type ActiveNewsletterType = {
  // This should match what's in the API code. Example: https://github.com/1440-Media/fourteen40wordpress/blob/main/wp-content/plugins/mt-1440-plugin/mt-1440-api.php#L1354
  apiListID: string;

  // The human-friendly newsletter name
  name: string;

  // The slug of the topic that matches what's in the database
  topicSlug?: string;

  // When present, this will show a "see example". Should point to a publicly-viewable version of an relevant newsletter.
  archiveLink?: string;

  // If an API request fails, this number will be used as a fallback for the subscriber count
  fallbackSubscriberCount: number;
};

export const ACTIVE_NEWSLETTERS = {
  // Temp removal to focus on B&F NL
  // topicsWeekly: {
  //   apiListID: 'topics_weekly',
  //   archiveLink: 'https://mailchi.mp/bd210800506a/whivg7pm75?e=685c623078',
  // },
  // topicsHealthAndMedicine: {
  //   apiListID: 'topics_health_and_medicine',
  //   topicSlug: 'health-and-medicine',
  //   archiveLink:
  //     'https://us15.campaign-archive.com/?u=0595a800ec399bf91203a5263&id=213b919e3f',
  // },
  dailyDigest: {
    name: 'Daily Digest',
    apiListID: 'digest',
    topicSlug: '',
    archiveLink: '',
    fallbackSubscriberCount: 4080744, // updated Dec 19 2024
    description:
      'Our flagship newsletter. 100+ sources, across culture, science, sports, politics, business, and more—all in a five-minute read.',
  },
  topicsBusinessAndFinance: {
    name: 'Business & Finance',
    apiListID: 'topics_business_and_finance',
    topicSlug: 'business-and-finance',
    archiveLink:
      'https://news.join1440.com/t/j-EF08561E71ABB06E2540EF23F30FEDED',
    fallbackSubscriberCount: 0,
    description:
      'A weekly newsletter focused on deep dives into business and finance topics, such as Venture Capital, Labor Unions, Minimum Wage and much more.',
  },
  topicsSocietyAndCulture: {
    name: 'Society & Culture',
    apiListID: 'topics_society_and_culture',
    topicSlug: 'society-and-culture',
    archiveLink:
      'https://link.join1440.com/view/67d0650462905ca1010c6479n9wxl.cow/df6f3509',
    fallbackSubscriberCount: 0,
    description:
      'A weekly newsletter offering deep dives into the worlds of art, music, literature, film, food, sports, entertainment, and more.',
  },
  topicsScienceAndTechnology: {
    name: 'Science & Technology',
    apiListID: 'topics_science_and_technology',
    topicSlug: 'science-technology',
    archiveLink: '',
    fallbackSubscriberCount: 0,
    description:
      'Weekly deep dives into fascinating topics ranging from Black Holes to Large Language Models, and much more (launches Tuesday, May 27!).',
  },
};
